import BookingReportFilter from './BookingReportFilter';

export default BookingReportFilter;
